/* eslint-disable */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
// import { PdfFillerCore } from '@panna/pdffiller';
import withRouter from 'src/hooks/withRouter';
import { confirmWrapper } from 'src/components/Dialog';
import { getContentType, getFileExtension } from 'src/components/elements/File/utils';
import DocumentAdd from './components/DocsAdd';
import API from '../../network';
import ViewRenderer from './views';
import {
  CandidateDocumentsViewRendererProps,
  UploadDocumentProps,
  DocumentResponse,
} from './types';
// import { getFileName } from './utils';

function CandidateDocuments() {
  const [loading, setLoading] = useState<boolean>(false);
  const [documentList, setDocumentList] = useState<DocumentResponse[]>([]);
  const candidateInfo = useSelector((state: any) => {
    return state?.selectedTalentPoolProfile?.candidateInfo
  });

  useEffect(() => {
    getAllDocuments();
  }, []);

  /**
   * getAllDocuments()
   * @param - no params
   * @returns - void promise
   * @description - get all the documents
   */
  const getAllDocuments = async (): Promise<void> => {
    setLoading(true);
    try {
      const response: DocumentResponse[] = await API
        .getInstance()
        .getCandidateDocuments(candidateInfo?.candidateId);
      setDocumentList(response);
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      setLoading(false);
    }
  };

  /**
   * onOpenDocumentAddPopup()
   * @param - no params
   * @returns - void promise
   * @description - display a popup to add document
   */
  const onOpenDocumentAddPopup = async (): Promise<void> => {
    await confirmWrapper('Add Document', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'xs',
      fullWidth: true,
      containerClasses: 'p-4',
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: (
        <DocumentAdd
          onUpload={onUpload}
          loading={loading}
        />
      ),
    });
  };

  /**
   * onUpload(data)
   * @param - data: UploadDocumentProps
   * @returns - void promise
   * @description - upload document - action can be only performed by HR
   */
  const onUpload = async (data: UploadDocumentProps): Promise<void> => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('document', data ? data?.attachment as File : '');
      formData.append('documentName', data.fileName);
      await API
        .getInstance()
        .documentUpload(candidateInfo?.candidateId, formData);
      await getAllDocuments();
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      setLoading(false);
    }
  };

  /**
   * onDocumentDownload(data)
   * @param - data: DocumentResponse
   * @returns - void promise
   * @description - download document
   */
  const onDocumentDownload = (doc: DocumentResponse): void => {
    window.open(doc.presignedUrl, '_blank');
  };

  /**
   * onDocumentView(data)
   * @param - data: DocumentResponse
   * @returns - void promise
   * @description - view document
   */
  const onDocumentView = async (doc: DocumentResponse): Promise<void> => {
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'md',
      fullWidth: true,
      containerClasses: 'pt-10',
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: (
        <div
          style={{
            border: '1px #4D586A solid',
            height: '80vh',
          }}
        >
          <DocViewer
            documents={[{
              uri: doc.presignedUrl,
              fileType: getContentType(doc.documentName, doc.documentURL),
            }]}
            config={{
              header: {
                disableHeader: true,
                disableFileName: false,
                retainURLParams: false,
              },
            }}
            pluginRenderers={DocViewerRenderers}
          />
          {/* {getFileExtension(doc.documentURL) === 'pdf' ? (
            <PdfFillerCore
              thumbnails
              height={78}
              pdfSource={doc.presignedUrl || ''}
            />
          ) : (
            <DocViewer
              documents={[{
                uri: doc.presignedUrl,
                fileType: getContentType(doc.documentName, doc.documentURL),
              }]}
              pluginRenderers={DocViewerRenderers}
            />
          )} */}
        </div>
      ),
    });
  };

  const viewProps: CandidateDocumentsViewRendererProps = {
    loading,
    documentList,
    onDocumentDownload,
    onDocumentView,
    onOpenDocumentAddPopup,
  };

  return <ViewRenderer {...viewProps} />;
}

export default withRouter(CandidateDocuments);
